<template>
  <div class="risk-dialog">
    <el-dialog
      class="hidden-detail-dlialog"
      :visible.sync="showDialog"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
      style="padding:0"
    >
      <div class="content">
        <div class="hidden-close" @click="close">
          关闭
        </div>
        <div class="content-title">
          <img v-if="fileIcon[params.type]" :src="require('@/assets/img/fileIcon/' + fileIcon[params.type])" alt="" />
          <span>
            {{ title }}
          </span>
        </div>
        <div class="select-box">
          <el-select
            v-model="schoolId"
            @change="schoolChange"
            clearable
            filterable
            size="small"
            placeholder="请选择学校"
            :popper-append-to-body="false"
          >
            <!-- <el-option label="全部" value=""></el-option> -->
            <el-option
              v-for="item in schoolList"
              :key="item.schoolId"
              :label="item.schoolName"
              :value="item.schoolId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="table-wrapper">
          <el-table
            style="margin-top:5px"
            :row-style="getRowClass"
            :cell-style="tableCellStyle"
            :header-row-style="getRowClass"
            :header-cell-style="getRowClass"
            :data="tableData"
            height="410px"
            border
            v-loading="tableLoading"
          >
            <el-table-column
              label="学校名称"
              show-overflow-tooltip
              align="center"
              prop="schoolName"
            >
            </el-table-column>
            <el-table-column
              label="名称"
              show-overflow-tooltip
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column
              label="类型"
              show-overflow-tooltip
              align="center"
              prop="type"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            :page-size="params.pageSize"
            :pager-count="5"
            :current-page="params.pageNum"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "fileDialog",
  props: {
    show: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    searchParams: {
      type: Object,
    },
  },
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      showDialog: false,
      params: {
        eduId: "", //教育局id
        regionCode: "", //区域编码
        eduBuresuType: "", //教育局类型
        type: "",
        pageNum: 1,
        pageSize: 20,
      },
      tableData: [],
      tableLoading: false,
      total: 0,
      fileIcon: [
        "file-icon-0.png", //器械
        "file-icon-9.png", //消防毯
        "file-icon-7.png", //其他
        "file-icon-3.png", //灭火器
        "file-icon-1.png", //食堂
        "file-icon-6.png", //留守儿童
        "file-icon-5.png", //特殊
        "file-icon-4.png", //器械
        "file-icon-2.png", //安保
        "file-icon-8.png", //安全通道
        "file-icon-10.png", //应急预案
        "file-icon-11.png", //安全制度管理
      ],
      schoolList: [],
      schoolId: "",
    };
  },

  created() {},
  mounted() {},
  methods: {
    async getFileList() {
      this.tableLoading = true;
      if (!this.params.schoolId) {
        delete this.params.schoolId
      }
      let req = Object.assign({}, this.params);
      let res = await this.$Http.getFileList(req);
      this.tableLoading = false;
      if (res.code == 200) {
        if (res.data) {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        } else {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        }
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 分页点击
    currentChange(val) {
      this.params.pageNum = val;
      this.getFileList();
    },
    close() {
      this.$emit("close");
    },
    // 修改 table cell边框的背景色
    tableCellStyle() {
      return "border-color: #868686;";
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#3f5c6d2c;color:#c4cdff;";
    },
    async getSchoolList() {
      let req = {
        eduId: this.eduInfo.eduId,
        regionCode: parseInt(this.eduInfo.regionCode),
        eduBuresuType: this.eduInfo.eduBuresuType,
      };
      let res = await this.$Http.getEduSchoolList(req);
      if (res.code == 200) {
        if (res.data) {
          this.schoolList = res.data || [];
        } else {
          this.schoolList = res.data || [];
        }
      } else if (res.code == 101) {
        this.schoolList = [];
      } else {
        this.schoolList = [];
      }
    },
    schoolChange(val) {
      this.params.schoolId = parseInt(val);
      this.getFileList();
    },
  },
  watch: {
    show: function(nval) {
      if (nval) {
        this.params = Object.assign({}, this.searchParams);
        this.params.pageNum = 1;
        this.params.pageSize = 20;
        this.total = 0;
        this.getSchoolList();
        this.getFileList();
      }
      this.showDialog = nval;
    },
  },
};
</script>
<style scoped lang="scss">
.risk-dialog {
  /deep/ .hidden-detail-dlialog {
    .el-dialog {
      width: 882px;
      height: 570px;
      // 已修改
      background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center
        no-repeat;
      background-size: 100% 100%;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
}
.select-box {
  position: relative;
  /deep/ .el-select{
    .el-input__inner {
      background-color: transparent;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c4f0ff;
      line-height: 20px;
    }
    .el-select-dropdown {
      background: rgba(24, 27, 108, 0.8);
      box-shadow: 0px 0px 28px 0px #3f78bc inset;
      position: absolute !important;
      top: 26px !important;
    }
    .el-select-dropdown__item {
      color: #ffffff;
    }
    .el-select-dropdown__item.hover {
      color: #c4f0ff;
      background: rgb(24, 27, 108);
    }
    .el-select-dropdown__item.selected,
    .el-select-dropdown__item.selected.hover {
      color: #409eff;
      background: rgb(24, 27, 108);
    }
  }
}
.content {
  padding: 12px 20px;
  width: 100%;
  height: 100%;
  position: relative;
  .hidden-close {
    width: 56px;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #d7deff;
    text-align: center;
    line-height: 25px;
    letter-spacing: 1px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .content-title {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 38px;
      height: 42px;
    }
    span {
      margin-left: 16px;
      font-size: 24px;
      color: #d7deff;
    }
  }
}
.table-wrapper {
  /deep/ .el-table {
    padding: 0px;
    background-color: transparent;
    .el-table__expanded-cell {
      background-color: transparent;
    }
    th,
    tr {
      background-color: transparent !important;
      &:hover td{
        background-color: transparent !important;
      }
    }
    .el-table--enable-row-transition {
      .el-table__body {
        td {
          background-color: transparent;
          color: #c4cdff;
        }
      }
    }
    .cell {
      background-color: transparent;
      color: #c4cdff;
    }
  }
}
.table-wrapper {
  /deep/ .el-table {
    padding: 0px;
    background-color: transparent;
    .el-table__expanded-cell {
      background-color: transparent;
    }
    th,
    tr {
      background-color: transparent !important;
      &:hover td{
        background-color: transparent !important;
      }
    }
    .el-table--enable-row-transition {
      .el-table__body {
        td {
          background-color: transparent;
          color: #c4cdff;
        }
      }
    }
    .cell {
      background-color: transparent;
      color: #c4cdff;
    }
  }
}
.pagination {
  /deep/ &.el-pagination {
  margin: 10px;
  float: right;
  background-color: transparent;
    .el-pagination__total {
      color: rgba(255, 255, 255, 0.8);
    }
    button{
      width: 28px;
      min-width: 28px;
      border-radius: 6px;
      background: transparent;
      border: 1px solid rgba(44,166,252,1);
      box-shadow: inset 0px 1px 16px 0px rgba(65, 77, 161, 0.5);
      &:hover {
        background: rgba(44,166,252,1);
      }
      &:disabled {
        background: transparent;
        cursor: default;
      }
      .el-icon {
        color: #ffffff;
        &.el-icon-arrow-right {
          position: relative;
          left: -4px;
        }
      }
    }
    .el-pager {
      li {
        color: rgba(255, 255, 255, 0.6);
        background: transparent;
        &:hover,
        &.active {
          color: #ffffff;
        }
      }
    }
  }
}
</style>
